import JavaPicture from '../images/Project/health.webp';
import CipherPicture from '../images/Project/CrackCipher.webp';
import Bridge from '../images/Project/Bridge.webp';
import NWS from '../images/Project/nws.webp';
import sharpeners from '../images/Project/sharpeners.webp';
import roadSaints from '../images/Project/roadSaints.webp';

export const projects = [
  {
    title: "RoadSaints: Unleash Your Ride's Potential with Premium Motorcycle Accessories",
    picture: roadSaints,
    details:
      "Welcome to Road Saints, your premier destination for top-tier motorcycle accessories. Discover meticulously curated high-performance helmets, innovative luggage solutions, and more. Elevate your biking experience with a seamless shopping journey, detailed insights, and responsive assistance. Join us to enhance your motorcycle adventures with unparalleled style and safety. Your journey to excellence begins here.",
    languages: "ReactJs, Asp.Net, SQL Server, Tailwind Css, JavaScript, C#",
    projectLink: "DualLink",
  },
  {
    title: "SHARPENERS EduHub: Your Path to Excellence in Education",
    picture: sharpeners,
    details:
      "The SHARPENERS website is a comprehensive platform designed to showcase a leading educational institution. It offers information about programs and degrees, online resources for students, news updates, and admissions details. The responsive website ensures accessibility across devices, making it a user-friendly hub for prospective students and current learners.",
    languages: "HTML, CSS, JavaScript, PHP, MySQL.",
    projectLink: "https://github.com/emonsingha209/SHARPENERS",
  },
  {
    title: "CryptoWeb: Journey into Ciphers - Unveiling the Art of Encryption and Decryption",
    picture: CipherPicture,
    details:
      "Introducing the Encryption and Decryption Website, seamlessly merging cryptography and web development. Explore classical ciphers like Caesar, Playfair, and Vigenère via a user-friendly interface. Prioritizing security and user experience, the platform offers an in-depth dive into each cipher mechanics, immersing users in the captivating world of encryption techniques. Embark on a journey to decode historical ciphers within this engaging project.",
    languages: "Next.js, TailwindCSS",
    liveDemoLink: "https://crackcipher.netlify.app/",
    projectLink: "https://github.com/emonsingha209/Crack-Cipher",
  },
  {
    title: "Nutrition and Workout System (Backend): Empowering Nutritionists, Trainers, and Clients for Optimal Fitness Success",
    picture: NWS,
    details:
      "Nutrition-and-workout-System is a software system built to provide a simple and convenient system for certified nutritionists and trainers to work with clients using the many useful features of the application. We hope that through this platform the certified nutritionists, trainers and clients can come together and collaborate to build perfect system for achieving fitness goals as effectively as possible.",
    languages: "TypeScript, NestJs",
    projectLink: "https://github.com/Ratul41Bhatt/Nutrition-and-Workout-System",
  },
  {
    title: "HealthConsult Pro: Your Personalized Symptom Analysis and Medical Scheduling Tool",
    picture: JavaPicture,
    details:
      "The Health Consultant Application is a Java-based tool that empowers users to input symptoms and receive personalized health recommendations. It employs evidence-based practices to predict potential diseases based on symptoms. Additionally, users can conveniently schedule appointments with doctors, ensuring timely and accurate medical attention to cater to their unique needs and preferences.",
    languages: "Java",
    projectLink: "https://github.com/emonsingha209/Health_Consultant",
  },
  {
    title: "OpenGL London Tower Bridge - A Digital Remake",
    picture: Bridge,
    details:
      "An OpenGL project about London iconic Tower Bridge, meticulously recreated with meticulous attention to detail, capturing its majesty and architectural finesse. This visually stunning experience offers viewers a captivating glimpse into the beauty of this historical landmark.",
    languages: "OpenGL",
    liveDemoLink:
      "https://drive.google.com/file/d/17pnlM2e0nUVA7bSfI87fT4gGDV7UaS5d/view?usp=sharing",
    projectLink: "https://github.com/emonsingha209/London-Tower-Bridge--Opengl",
  },
];
